export const Z_INDEX = {
  modal: 1000,
  drawer: 1000,
  emojiModal: 1000,
  customFilter: 1001,
  notificationModal: 1001,
  sidebar: 800,
  appNavigationTooltip: 810, // sidebar + 10
  backdrop: 900,
  loader: 1200,
  giftMessagePreview: 9,
  iphoneNotch: 3,
  iphoneHeader: 2,
  iphoneHeaderIcons: 4,
  toast: 1002,
  standart1: 1,
  standart2: 2,
  standart3: 3
};
